import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import type { ReactNode } from "react";
import { LegacyNavLink } from "../../components/LegacyNavLink";
import classes from "./NavigationButton.module.css";

interface NavigationButtonProps {
  disabled?: boolean;
  href: string;
  icon: ReactNode;
  showTooltip?: boolean;
  text: string;
}

export const NavigationButton = (props: NavigationButtonProps) => {
  const { disabled, href, icon, showTooltip, text } = props;
  const activeClassName = classes.active;

  return (
    <ListItem className={classes.item} disablePadding>
      <ListItemButton
        className={classes.button}
        disabled={disabled}
        {...{
          activeClassName,
          component: LegacyNavLink as any,
          href,
        }}
      >
        {/*
         * The tooltip takes over once the text is hidden by the collapsed edge.
         * It wraps the rail, so that it anchors to what stays visible.
         */}
        <Tooltip placement="right" title={showTooltip ? text : ""}>
          <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
        </Tooltip>
        <ListItemText
          primary={text}
          slotProps={{ primary: { noWrap: true } }}
        />
      </ListItemButton>
    </ListItem>
  );
};
